if (!customElements.get('dispatch-countdown')) {
  const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  class DispatchCountdown extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.dispatch-countdown__text');
      this.cutoff = parseInt(this.dataset.cutoffHour, 10) * 3600;
      this.days = this.dataset.days
        .split(',')
        .filter(Boolean)
        .map((day) => parseInt(day, 10));

      try {
        // Reading the time in the store's timezone means the countdown is right
        // wherever the shopper is, and daylight saving is handled by the browser.
        this.formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: this.dataset.timezone,
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23',
        });
      } catch (error) {
        // Invalid timezone: leave the static fallback message in place.
        return;
      }

      if (!this.text || Number.isNaN(this.cutoff) || this.days.length === 0) return;

      this.update();
      this.interval = setInterval(this.update.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    getStoreTime() {
      const parts = {};
      this.formatter.formatToParts(new Date()).forEach(({ type, value }) => {
        parts[type] = value;
      });

      return {
        weekday: WEEKDAYS.indexOf(parts.weekday),
        seconds: parseInt(parts.hour, 10) * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10),
      };
    }

    update() {
      const { weekday, seconds } = this.getStoreTime();

      if (this.days.includes(weekday) && seconds < this.cutoff) {
        this.render(this.dataset.message, '[time]', this.formatDuration(this.cutoff - seconds));
        return;
      }

      let offset = 1;
      while (!this.days.includes((weekday + offset) % 7)) offset++;

      const day = offset === 1 ? 'tomorrow' : WEEKDAY_NAMES[(weekday + offset) % 7];
      this.render(this.dataset.closedMessage, '[day]', day);
    }

    formatDuration(totalSeconds) {
      // Round up so the last minute reads "1m" rather than "0m".
      const totalMinutes = Math.ceil(totalSeconds / 60);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      if (hours > 0) return `${hours}h ${String(minutes).padStart(2, '0')}m`;
      return `${minutes}m`;
    }

    render(message, placeholder, value) {
      const key = `${message}|${value}`;
      if (key === this.rendered) return;
      this.rendered = key;

      const [before, after = ''] = message.split(placeholder);
      const highlight = document.createElement('strong');
      highlight.className = 'dispatch-countdown__time';
      highlight.textContent = value;

      this.text.replaceChildren(before, ...(message.includes(placeholder) ? [highlight, after] : []));
    }
  }

  customElements.define('dispatch-countdown', DispatchCountdown);
}
